const ud = JSON.parse(localStorage.getItem('ud'))
const posId = JSON.parse(localStorage.getItem('posId'))
const posName = localStorage.getItem('posName');
const posData = JSON.parse(localStorage.getItem('posData'))
const initialState = ud
	? {status: {loggedIn: true}, user: ud, posId: posId, posName: posName, posData: posData}
	: {status: {loggedIn: false}, user: null, posId: posId, posName: posName, posData: null}

export const auth = {
	namespace: true,
	state: initialState,
	actions: {
		setupPosId({commit, dispatch}, data) {
			localStorage.setItem('posId', JSON.stringify(data));
			commit('SETUP_POS_ID', data);
		},
		savePosData({commit, dispatch}, data) {
			localStorage.setItem('posData', JSON.stringify(data));
			localStorage.setItem('posName', data?.department?.name ?? '');
			commit('SAVE_POS_DATA', data);
		},
		savePosName({commit, dispatch}, name) {
			localStorage.setItem('posName', name);
			commit('SAVE_POS_NAME', name);
		},
		loginUser({commit, dispatch}, data) {
			localStorage.setItem('ud', JSON.stringify(data));
			commit('LOGIN_USER', data);
		},
		logoutUser({commit, dispatch}) {
			localStorage.removeItem('ud');
			localStorage.removeItem('posData');
			localStorage.removeItem('checksTab');
			commit('LOGOUT_USER');
		},
		terminalReset({commit, state}) {
			localStorage.clear();
			commit('TERMINAL_RESET');
		}
	},
	mutations: {
		SETUP_POS_ID(state, data) {
			state.posId = data;
		},
		SAVE_POS_NAME(state, name) {
			state.posName = name;
		},
		SAVE_POS_DATA(state, data) {
			state.posData = data;
			state.posName = data?.department?.name;
		},
		LOGIN_USER(state, data) {
			state.status = {loggedIn: true};
			state.user = data;
		},
		LOGOUT_USER(state) {
			state.status = {loggedIn: false};
			state.user = null;
			state.posData = null;
		},
		TERMINAL_RESET(state) {
			state.posId = null;
			state.posName = null;
			state.posData = null;
			state.status = {loggedIn: false};
			state.user = null;
		}
	}
}
